<div class="expansionTitle" [ngStyle]="titleStyle" [class.titleBackground]="elementOnPanel" [style.height]="titleHeight"
  (mouseover)="markHover(true)" (mouseleave)="markHover(false)" (click)="toggleExpansion()">
  <div class="titleBox">
    @if (leftPositionedArrow) {
      <mat-icon svgIcon={{getIconName()}} class="expandIcon"></mat-icon>
    }
    <ng-content select="[titleContent]"></ng-content>
  </div>
  <div class="controlButtonPlaceHolder" (click)="stopPropagationOfHoverContentClick($event)">
    @if (hover) {
      <ng-content select="[hoverContent]"></ng-content>
    }
  </div>
  @if (!leftPositionedArrow) {
    <mat-icon svgIcon={{getIconName()}} class="expandIcon"></mat-icon>
  }
</div>
<div class="expansionContent" [class.padLeft]="leftPositionedArrow || forcePadLeft" [class.opened]="expanded">
  <ng-content select="[content]"></ng-content>
</div>
